import { Alert } from 'antd';
import { useEffect, useRef, useState } from 'react';

export const useRequestsTour = (setActiveTab, flag) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [allowNextStep, setAllowNextStep] = useState({ deviceFlag: false, localMachinesFlag: false });

  const approveDeviceRef = useRef(null);
  const rejectDeviceRef = useRef(null);
  const requestDateColumnRef = useRef(null);

  useEffect(() => {
    setAllowNextStep(flag);
  }, [flag]);

  const steps = [
    {
      title: 'Раздел "Запросы"',
      description: (
        <>
          <p>
            Добро пожаловать в раздел «Запросы» — здесь вы оперативно обрабатываете входящие заявки на добавление новых
            устройств и локальных серверов. Быстрая проверка и удобное подтверждение обеспечивают полный контроль над
            процессом.
          </p>
          {!allowNextStep && (
            <Alert message={'Чтобы продолжить тур зарегистрируйте заявку устройства!'} style={{ marginTop: '10px' }} />
          )}
        </>
      ),
      target: null,
    },
    {
      title: 'Запросы устройств',
      description: 'В этом списке отображаются устройства, ожидающие подтверждения для регистрации на сервере.',
      target: null,
      beforeNext: () => setActiveTab('devices'),
    },
    {
      title: 'Подтверждение устройства',
      description:
        'Нажмите, чтобы подтвердить запрос. Устройство будет зарегистрировано и сразу появится в списке устройств.',
      target: () => approveDeviceRef.current,
    },
    {
      title: 'Отмена запроса устройства',
      description: (
        <>
          <p>Нажмите, чтобы отклонить запрос — устройство не будет добавлено, а заявка исчезнет из таблицы.</p>
          {!allowNextStep && (
            <Alert
              message={'Чтобы продолжить тур зарегистрируйте заявку локального сервера!'}
              style={{ marginTop: '10px' }}
            />
          )}
        </>
      ),
      target: () => rejectDeviceRef.current,
    },
    {
      title: 'Переход к серверам',
      description: 'Здесь отображаются заявки на регистрацию локальных серверов, отправленные пользователями.',
      target: null,
      beforeNext: () => setActiveTab('localmachines'),
    },
    {
      title: 'Подтверждение сервера',
      description:
        'Подтвердите запрос — система автоматически сформирует лицензионный ключ, который станет доступен для скачивания в разделе «Локальные сервера».',
      target: null,
    },
    {
      title: 'Отмена запроса сервера',
      description: 'Отмените запрос — сервер не будет зарегистрирован и удалится из списка заявок.',
      target: () => rejectDeviceRef.current,
    },
    {
      title: 'Дата отправки запроса',
      description:
        'В таблице указана дата подачи заявки на добавление сервера — самые свежие заявки отображаются первыми.',
      target: null,
    },
  ];

  const startTour = () => {
    setCurrentStep(0);
    setIsTourOpen(true);
  };

  const handleTourChange = nextStep => {
    if ((!allowNextStep && currentStep === 0) || (!allowNextStep && currentStep === 3)) {
      return;
    }

    setCurrentStep(nextStep);
  };

  const handleClose = () => {
    setIsTourOpen(false);
  };

  return {
    approveDeviceRef,
    rejectDeviceRef,
    requestDateColumnRef,
    steps,
    startTour,
    handleTourChange,
    handleClose,
    currentStep,
    isTourOpen,
  };
};
